import * as users from "./endpoints/users";
import * as products from "./endpoints/products";
import * as drivers from "./endpoints/drivers";
import * as clients from "./endpoints/clients";
import * as orders from "./endpoints/orders";
import * as quotations from "./endpoints/quotations";
import * as certificates from "./endpoints/certificates";
import * as finance from "./endpoints/finance";
import * as bankAccounts from "./endpoints/bank_accounts";
import * as branchs from "./endpoints/branchs";
import * as measurements from "./endpoints/measurements";
import * as tariffs from "./endpoints/tariffs";
import * as services from "./endpoints/services";
import dashboardEndpoints from "./endpoints/dashboard";
import purchaseOrdersAPI from "./endpoints/purchaseOrders";
import suppliersAPI from "./endpoints/suppliers";
import * as recipes from "./endpoints/recipes";
import * as config from "./endpoints/config";
import promotionsAPI from "./endpoints/promotions";
import tablesAPI from "./endpoints/tables";
import schedulingAPI from "./endpoints/scheduling";
import employeesAPI from "./endpoints/employees";
import equipmentAPI from "./endpoints/equipment";
import * as payrollConcepts from "./endpoints/payrollConcepts";
import * as system from "./endpoints/system";
import * as notifications from "./endpoints/notifications";
import * as backups from "./endpoints/backups";
import { modulePlansAPI } from "./endpoints/globalAdmin";

const api = {
  system: {
    checkHealth: system.checkHealth,
  },
  audit: {
    list_logs: config.listAuditLogs,
  },
  notifications: {
    list: notifications.list,
    create: notifications.create,
    update: notifications.update,
    remove: notifications.remove,
    getMyNotifications: notifications.getMyNotifications,
  },
  backups: {
    list: backups.list,
    create: backups.create,
    getDownloadUrl: backups.getDownloadUrl,
    download: backups.download,
  },
  config: {
    get: config.getGlobalConfig,
    global: config.getGlobalConfig,
    updateGlobal: config.updateGlobalConfig,
    getMyDefaultBranchTheme: config.getMyDefaultBranchTheme,
    update: config.updateGlobalConfig,
    getPOSConfig: config.getPOSConfig,
    updatePOSConfig: config.updatePOSConfig,
    modules: config.moduleConfigs, // ✅ Nuevo endpoint
    testSimpleAPI: config.testSimpleAPI, // ✅ Nuevo endpoint
  },
  auth: {
    login: users.login,
    get_profile: users.get_profile,
    forgot_password: users.forgot_password,
    reset_password_confirm: users.reset_password_confirm,
  },
  users: {
    list: users.list,
    list_for_product_assignment: users.list_for_product_assignment,
    list_meters: users.list_meters,
    create: users.create,
    signup: users.signup,
    update: users.update,
    delete: users.destroy,
    destroy: users.destroy, // ✅ Alias para consistencia
    retrieve: users.retrieve,
    get_my_profile: users.get_my_profile,
    update_my_profile: users.update_my_profile,
    get_user_product_assignment: users.get_user_product_assignment,
    update_user_product_assignment: users.update_user_product_assignment,
    change_password: users.change_password,
    generate_password: users.generate_password,
    toggle_user_status: users.toggle_user_status,
    change_user_role: users.change_user_role,
    toggle_branch_assignment_status: users.toggle_branch_assignment_status,
    change_assignment_role: users.change_assignment_role,
  },
  branchs: {
    list: branchs.list,
    create: branchs.create,
    update: branchs.update,
    destroy: branchs.destroy,
    retrieve: branchs.retrieve,
    my_branches: branchs.my_branches,
    my_branches_for_filters: branchs.my_branches_for_filters,
    my_branches_select: branchs.my_branches_select,
    get_branch_users: branchs.get_branch_users,
    invite_user: branchs.invite_user,
    update_user_role: branchs.update_user_role,
    remove_user: branchs.remove_user,
    toggle_user_status: branchs.toggle_user_status,
    change_user_branch: branchs.change_user_branch,
    my_invitations: branchs.my_invitations,
    accept_invitation: branchs.accept_invitation,
    reject_invitation: branchs.reject_invitation,
    leave_branch: branchs.leave_branch,
    transfer_ownership: branchs.transfer_ownership,
    get_available_users: branchs.get_available_users,
    assign_existing_user: branchs.assign_existing_user,

    getBranchRoles: branchs.getBranchRoles, // ✅ Role management
    updateBranchRoles: branchs.updateBranchRoles,
    getBranchThemeConfig: branchs.getBranchThemeConfig,
    updateBranchThemeConfig: branchs.updateBranchThemeConfig,
    setBranchAsDefault: branchs.setBranchAsDefault,
    setActiveBranch: branchs.setActiveBranch, // ✅ NUEVO: Cambiar sucursal activa
    // ✅ Endpoints públicos para login dinámico
    getPublicLoginTheme: branchs.getPublicLoginTheme,
    listPublicLoginBranches: branchs.listPublicLoginBranches,
    // ✅ Endpoints para configuración POS por sucursal
    getBranchPOSConfig: branchs.getBranchPOSConfig,
    updateBranchPOSConfig: branchs.updateBranchPOSConfig,
  },
  // ✅ Módulos Plans API (para Global Admin Dashboard)
  modulePlans: {
    getAll: modulePlansAPI.getAll,
    get: modulePlansAPI.get,
    create: modulePlansAPI.create,
    update: modulePlansAPI.update,
    delete: modulePlansAPI.delete,
  },
  // Alias para compatibilidad: 'branches' funciona igual que 'branchs'
  branches: {
    getPublicLoginTheme: branchs.getPublicLoginTheme,
    listPublicLoginBranches: branchs.listPublicLoginBranches,
  },
  products: {
    list: products.list,
    create: products.create,
    update: products.update,
    delete: products.destroy,
    categories: { ...products.categories },
    // ✅ Endpoints específicos por tipo de producto
    getMeasurementMaterials: products.getMeasurementMaterials,
    getSupplierProducts: products.getSupplierProducts,
    getCertificateProducts: products.getCertificateProducts,
    getByType: products.getByType,
    bulkImport: products.bulkImport,
  },
  clients: {
    list: clients.list,
    get: clients.get,
    create: clients.create,
    update: clients.update,
    delete: clients.destroy,
    // Alias para compatibilidad con código existente
    list_all: clients.list_all,
    total: clients.list_all,
    search: clients.search,
    get_stats: clients.get_stats,
    bulkImport: clients.bulkImport,
    getClientsWithPendingRevenues: clients.getClientsWithPendingRevenues,
    contacts: { ...clients.contacts },
    jobTitles: { ...clients.jobTitles },
    departments: { ...clients.departments },
  },
  suppliers: {
    list: suppliersAPI.list,
    create: suppliersAPI.create,
    update: suppliersAPI.update,
    delete: suppliersAPI.remove,
    retrieve: suppliersAPI.getDetail,
    get_stats: suppliersAPI.get_stats,
    getProducts: suppliersAPI.getProducts,
    supplierProducts: suppliersAPI.supplierProducts,
    purchaseOrders: suppliersAPI.purchaseOrders,
    purchaseOrderItems: suppliersAPI.purchaseOrderItems,
    purchaseOrderPayments: suppliersAPI.purchaseOrderPayments,
  },
  drivers: {
    list: drivers.list,
    create: drivers.create,
    update: drivers.update,
    delete: drivers.destroy,
    retrieve: drivers.retrieve,
    total: drivers.list_all,
    // Nuevos endpoints del sistema DriverProfile
    get_available_drivers: drivers.get_available_drivers,
    calculate_delivery_cost: drivers.calculate_delivery_cost,
    get_driver_performance: drivers.get_driver_performance,
    update_driver_availability: drivers.update_driver_availability,
    get_driver_dashboard: drivers.get_driver_dashboard,
  },
  orders: {
    list: orders.list,
    retrieve: orders.retrieve,
    create: orders.create,
    update: orders.update,
    delete: orders.destroy,
    register_products: { ...orders.register_products },
    getTaxDocument: orders.getTaxDocument,
    generateBoletaPdf: orders.generateBoletaPdf,
    generateBoletaDomiciliariaPdf: orders.generateBoletaDomiciliariaPdf,
  },
  quotations: {
    list: quotations.list,
    retrieve: quotations.retrieve,
    create: quotations.create,
    update: quotations.update,
    delete: quotations.destroy,
    get_stats: quotations.get_stats,
    convertToOrder: quotations.convertToOrder,
  },
  certificates: {
    list: certificates.list,
    create: certificates.create,
    update: certificates.update,
    delete: certificates.deleteCertificate,
    generatePdf: certificates.generatePdf,
    downloadPdf: certificates.downloadPdf,
    previewHtml: certificates.previewHtml,
    revoke: certificates.revoke,
    verify: certificates.verify,
    getStats: certificates.getStats,
    createAgreement: certificates.createAgreement,
    getInstallments: certificates.getInstallments,
    payInstallment: certificates.payInstallment,
    templates: {
      list: certificates.listTemplates,
      create: certificates.createTemplate,
      update: certificates.updateTemplate,
      delete: certificates.deleteTemplate,
    },
  },

  // MÓDULO DE FINANZAS COMPLETO - Gestión unificada
  finance: {
    // Configuración financiera por sucursal
    branchConfigs: {
      list: finance.branchConfigs.list,
      get: finance.branchConfigs.get,
      getByBranch: finance.branchConfigs.getByBranch,
      formatOnly: finance.branchConfigs.formatOnly,
      formatPreview: finance.branchConfigs.formatPreview,
      create: finance.branchConfigs.create,
      update: finance.branchConfigs.update,
      delete: finance.branchConfigs.delete,
    },
    // Métodos de pago
    paymentMethods: {
      list: finance.payment_methods.list,
      getActive: finance.payment_methods.getActive,
      create: finance.payment_methods.create,
      update: finance.payment_methods.update,
      delete: finance.payment_methods.delete,
    },
    // Pagos unificados
    payments: {
      list: finance.payments.list,
      get: finance.payments.get,
      create: finance.payments.create,
      update: finance.payments.update,
      delete: finance.payments.delete,
      getSummary: finance.payments.getSummary,
      process: finance.payments.process,
      cancel: finance.payments.cancel,
      recover: finance.payments.recover,
      refund: finance.payments.refund,
      getStats: finance.payments.getStats,
      changeDirection: finance.payments.changeDirection,
      exportToExcel: finance.payments.exportToExcel,
      generatePdf: finance.payments.generatePdf,
      downloadVoucher: finance.payments.downloadVoucher,
    },
    // Ingresos (Revenues)
    revenues: {
      list: finance.revenuesModule.list,
      get: finance.revenuesModule.get,
      create: finance.revenuesModule.create,
      update: finance.revenuesModule.update,
      delete: finance.revenuesModule.delete,
      getSummary: finance.revenuesModule.getSummary,
      getPending: finance.revenuesModule.getPending,
      getPendingByClient: finance.revenuesModule.getPendingByClient,
      getReceived: finance.revenuesModule.getReceived,
      markAsReceived: finance.revenuesModule.markAsReceived,
      markAsUnpaid: finance.revenuesModule.markAsUnpaid,
      updateStatus: finance.revenuesModule.updateStatus,
      addPayment: finance.revenuesModule.addPayment,
      getPayments: finance.revenuesModule.getPayments,
      convertToExpense: finance.revenuesModule.convertToExpense,
      generateBoletaPdf: finance.revenuesModule.generateBoletaPdf,
      downloadVoucher: finance.revenuesModule.downloadVoucher,
    },
    // Alias para compatibilidad: revenuesModule también funciona
    revenuesModule: {
      list: finance.revenuesModule.list,
      get: finance.revenuesModule.get,
      create: finance.revenuesModule.create,
      update: finance.revenuesModule.update,
      delete: finance.revenuesModule.delete,
      getSummary: finance.revenuesModule.getSummary,
      getPending: finance.revenuesModule.getPending,
      getReceived: finance.revenuesModule.getReceived,
      markAsReceived: finance.revenuesModule.markAsReceived,
      markAsUnpaid: finance.revenuesModule.markAsUnpaid,
      updateStatus: finance.revenuesModule.updateStatus,
      addPayment: finance.revenuesModule.addPayment,
      getPayments: finance.revenuesModule.getPayments,
      convertToExpense: finance.revenuesModule.convertToExpense,
      generateBoletaPdf: finance.revenuesModule.generateBoletaPdf,
      downloadVoucher: finance.revenuesModule.downloadVoucher,
      exportToExcel: finance.revenuesModule.exportToExcel,
      getPendingByClient: finance.revenuesModule.getPendingByClient,
    },
    // Categorías de ingresos
    revenueCategories: {
      list: finance.revenueCategories.list,
      create: finance.revenueCategories.create,
      update: finance.revenueCategories.update,
      delete: finance.revenueCategories.delete,
    },
    // Gastos (Expenses)
    expenses: {
      list: finance.expensesModule.list,
      get: finance.expensesModule.get,
      create: finance.expensesModule.create,
      update: finance.expensesModule.update,
      delete: finance.expensesModule.delete,
      getActive: finance.expensesModule.getActive,
      getSummary: finance.expensesModule.getSummary,
      updateStatus: finance.expensesModule.updateStatus,
      getByFrequency: finance.expensesModule.getByFrequency,
      addPayment: finance.expensesModule.addPayment,
      getPayments: finance.expensesModule.getPayments,
      convertToRevenue: finance.expensesModule.convertToRevenue,
      downloadVoucher: finance.expensesModule.downloadVoucher,
      cancelExpense: finance.expensesModule.cancelExpense,
    },
    // Alias para compatibilidad: expensesModule también funciona
    expensesModule: {
      list: finance.expensesModule.list,
      get: finance.expensesModule.get,
      create: finance.expensesModule.create,
      update: finance.expensesModule.update,
      delete: finance.expensesModule.delete,
      getActive: finance.expensesModule.getActive,
      getSummary: finance.expensesModule.getSummary,
      updateStatus: finance.expensesModule.updateStatus,
      getByFrequency: finance.expensesModule.getByFrequency,
      addPayment: finance.expensesModule.addPayment,
      getPayments: finance.expensesModule.getPayments,
      convertToRevenue: finance.expensesModule.convertToRevenue,
      downloadVoucher: finance.expensesModule.downloadVoucher,
      exportToExcel: finance.expensesModule.exportToExcel,
      cancelExpense: finance.expensesModule.cancelExpense,
    },
    // Nómina
    payroll: {
      periods: {
        list: finance.payrollModule.periods.list,
        get: finance.payrollModule.periods.get,
        create: finance.payrollModule.periods.create,
        update: finance.payrollModule.periods.update,
        partialUpdate: finance.payrollModule.periods.partialUpdate,
        delete: finance.payrollModule.periods.delete,
        calculatePayroll: finance.payrollModule.periods.calculatePayroll,
        processAllPayments: finance.payrollModule.periods.processAllPayments,
        getSummary: finance.payrollModule.periods.getSummary,
      },
      entries: {
        list: finance.payrollModule.entries.list,
        get: finance.payrollModule.entries.get,
        create: finance.payrollModule.entries.create,
        update: finance.payrollModule.entries.update,
        partialUpdate: finance.payrollModule.entries.partialUpdate,
        delete: finance.payrollModule.entries.delete,
        applyDeductions: finance.payrollModule.entries.applyDeductions,
        applyBonuses: finance.payrollModule.entries.applyBonuses,
        processPayment: finance.payrollModule.entries.processPayment,
      },
      payments: {
        list: finance.payrollModule.payments.list,
        get: finance.payrollModule.payments.get,
      },
    },
    // Categorías de gastos
    expenseCategories: {
      list: finance.expenseCategories.list,
      create: finance.expenseCategories.create,
      update: finance.expenseCategories.update,
      delete: finance.expenseCategories.delete,
    },
    // Folios SII (CAF)
    folios: {
      list: finance.folios.list,
      get: finance.folios.get,
      create: finance.folios.create,
      update: finance.folios.update,
      delete: finance.folios.delete,
      getAvailable: finance.folios.getAvailable,
      checkAlerts: finance.folios.checkAlerts,
      getSummary: finance.folios.getSummary,
      toggleActive: finance.folios.toggleActive,
      updateAlert: finance.folios.updateAlert,
    },
    // Cuentas Bancarias
    bankAccounts: {
      // CRUD de cuentas bancarias
      list: bankAccounts.getBankAccounts,
      get: bankAccounts.getBankAccountById,
      create: bankAccounts.createBankAccount,
      update: bankAccounts.updateBankAccount,
      patch: bankAccounts.patchBankAccount,
      delete: bankAccounts.deleteBankAccount,
      // Cuenta predeterminada
      getDefault: bankAccounts.getDefaultBankAccount,
      setDefault: bankAccounts.setDefaultBankAccount,
      // Resúmenes y balances
      getBalanceSummary: bankAccounts.getBankAccountBalanceSummary,
      getSummaryByBranch: bankAccounts.getBankAccountsSummaryByBranch,
      getTransactions: bankAccounts.getBankAccountTransactions,
    },
    // Bancos (catálogo)
    banks: {
      list: bankAccounts.getBanks,
      get: bankAccounts.getBankById,
      create: bankAccounts.createBank,
      update: bankAccounts.updateBank,
      delete: bankAccounts.deleteBank,
      getPopular: bankAccounts.getPopularBanks,
      getChileanChoices: bankAccounts.getChileanBankChoices,
    },
    // Asociaciones Cliente-Cuenta Bancaria
    clientBankAccounts: {
      list: bankAccounts.getClientBankAccounts,
      get: bankAccounts.getClientBankAccountById,
      create: bankAccounts.createClientBankAccount,
      update: bankAccounts.updateClientBankAccount,
      delete: bankAccounts.deleteClientBankAccount,
      getByClient: bankAccounts.getClientBankAccountsByClient,
      getByAccount: bankAccounts.getClientBankAccountsByAccount,
      setDefault: bankAccounts.setDefaultClientBankAccount,
    },
    // Reconciliación Bancaria
    reconciliations: {
      list: bankAccounts.getBankReconciliations,
      get: bankAccounts.getBankReconciliationById,
      create: bankAccounts.createBankReconciliation,
      update: bankAccounts.updateBankReconciliation,
      delete: bankAccounts.deleteBankReconciliation,
      markAsBalanced: bankAccounts.markReconciliationAsBalanced,
      validate: bankAccounts.validateReconciliation,
      markAsPending: bankAccounts.markReconciliationAsPending,
      getPending: bankAccounts.getPendingReconciliations,
      getSummary: bankAccounts.getReconciliationSummary,
    },
    // Tipos de documento SII
    DOCUMENT_TYPES: finance.DOCUMENT_TYPES,
    DOCUMENT_TYPE_LABELS: finance.DOCUMENT_TYPE_LABELS,
    // Constantes
    PAYMENT_TYPES: finance.PAYMENT_TYPES,
    PAYMENT_STATUSES: finance.PAYMENT_STATUSES,
    REVENUE_TYPES: finance.REVENUE_TYPES,
    REVENUE_STATUSES: finance.REVENUE_STATUSES,
    REVENUE_CATEGORY_TYPES: finance.REVENUE_CATEGORY_TYPES,
    EXPENSE_CATEGORY_TYPES: finance.EXPENSE_CATEGORY_TYPES,
    EXPENSE_FREQUENCIES: finance.EXPENSE_FREQUENCIES,
    EXPENSE_STATUSES: finance.EXPENSE_STATUSES,
  },

  dashboard: dashboardEndpoints,
  measurements: {
    deleteWithRelated: measurements.deleteWithRelated,
    // API principal de mediciones
    list: measurements.list,
    get: measurements.get,
    create: measurements.create,
    createWithOrder: measurements.createWithOrder,
    update: measurements.update,
    destroy: measurements.destroy,
    verify: measurements.verify,
    toggleVerify: measurements.toggleVerify,
    getAssociatedOrder: measurements.getAssociatedOrder,
    getAssociatedRevenue: measurements.getAssociatedRevenue,
    getMyMeasurements: measurements.getMyMeasurements,
    generatePDF: measurements.generatePDF,
    downloadPDF: measurements.downloadPDF,

    // Puntos de medición
    measurementPoints: measurements.measurementPoints,

    // Tipos de medición
    measurementTypes: measurements.measurementTypes,
  },
  tariffs: {
    // Tarifarios
    list: tariffs.list,
    create: tariffs.create,
    update: tariffs.update,
    delete: tariffs.destroy,
    calculate: tariffs.calculate,
    getRanges: tariffs.getRanges,
    bulkImport: tariffs.bulkImport,

    // Rangos de tarifarios
    ranges: {
      list: tariffs.listRanges,
      create: tariffs.createRange,
      update: tariffs.updateRange,
      delete: tariffs.destroyRange,
    },

    // Descuentos
    discounts: {
      list: tariffs.listDiscounts,
      create: tariffs.createDiscount,
      update: tariffs.updateDiscount,
      delete: tariffs.destroyDiscount,
      getRanges: tariffs.getDiscountRanges,
      getBeneficiaries: tariffs.getDiscountBeneficiaries,
    },

    // Rangos de descuentos
    discountRanges: {
      list: tariffs.listDiscountRanges,
      create: tariffs.createDiscountRange,
      update: tariffs.updateDiscountRange,
      delete: tariffs.destroyDiscountRange,
    },

    // Beneficiarios
    beneficiaries: {
      list: tariffs.listBeneficiaries,
      create: tariffs.createBeneficiary,
      update: tariffs.updateBeneficiary,
      delete: tariffs.destroyBeneficiary,
      getByUser: tariffs.getBeneficiariesByUser,
    },

    // Puntos de medición
    measurementPoints: {
      list: tariffs.getMeasurementPoints,
    },
  },
  services: {
    // Servicios
    list: services.list,
    get: services.retrieve,
    create: services.create,
    update: services.update,
    delete: services.destroy,
    getSummary: services.getSummary,
    getByCategory: services.getByCategory,
    // Categorías de servicios
    categories: {
      list: services.listCategories,
      get: services.retrieveCategory,
      create: services.createCategory,
      update: services.updateCategory,
      delete: services.destroyCategory,
    },
  },
  recipes: {
    // Recetas
    list: recipes.list,
    get: recipes.retrieve,
    create: recipes.create,
    update: recipes.update,
    delete: recipes.destroy,
    dashboard: recipes.dashboard,
    scale: recipes.scale,
    // Ingredientes de recetas
    listIngredients: recipes.listIngredients,
    createIngredient: recipes.createIngredient,
    updateIngredient: recipes.updateIngredient,
    deleteIngredient: recipes.deleteIngredient,
    // Nutrición
    calculateNutrition: recipes.calculateNutrition,
    updateNutrition: recipes.updateNutrition,
    getNutritionLabel: recipes.getNutritionLabel,
    downloadNutritionLabelPDF: recipes.downloadNutritionLabelPDF,
    getNutritionalIngredients: recipes.getNutritionalIngredients,
    statsDashboard: recipes.statsDashboard,
    // Costos
    calculateCost: recipes.calculateCost,
    updateCosts: recipes.updateCosts,
    profitabilityAnalysis: recipes.profitabilityAnalysis,
    costComparison: recipes.costComparison,
  },
  promotions: {
    list: promotionsAPI.list,
    get: promotionsAPI.get,
    create: promotionsAPI.create,
    update: promotionsAPI.update,
    partialUpdate: promotionsAPI.partialUpdate,
    remove: promotionsAPI.remove,
    validateCode: promotionsAPI.validateCode,
    applyDiscount: promotionsAPI.applyDiscount,
    getStats: promotionsAPI.getStats,
    usage: {
      list: promotionsAPI.usage.list,
      get: promotionsAPI.usage.get,
    },
  },
  tables: {
    list: tablesAPI.list,
    get: tablesAPI.get,
    create: tablesAPI.create,
    update: tablesAPI.update,
    partialUpdate: tablesAPI.partialUpdate,
    remove: tablesAPI.remove,
    getAvailable: tablesAPI.getAvailable,
    getStatusSummary: tablesAPI.getStatusSummary,
    occupy: tablesAPI.occupy,
    bulkUpdateStatus: tablesAPI.bulkUpdateStatus,
    getByBranch: tablesAPI.getByBranch,
  },
  scheduling: {
    calendars: schedulingAPI.calendars,
    bookings: schedulingAPI.bookings,
    meetings: schedulingAPI.meetings,
    tasks: schedulingAPI.tasks,
    schedules: schedulingAPI.schedules,
    resources: schedulingAPI.resources,
    getDashboard: schedulingAPI.getDashboard,
  },
  employees: {
    list: employeesAPI.list,
    get: employeesAPI.get,
    create: employeesAPI.create,
    update: employeesAPI.update,
    partialUpdate: employeesAPI.partialUpdate,
    remove: employeesAPI.remove,
    // Conceptos de nómina
    payrollConcepts: {
      list: payrollConcepts.getPayrollConcepts,
      getBonuses: payrollConcepts.getBonusConcepts,
      getDeductions: payrollConcepts.getDeductionConcepts,
      create: payrollConcepts.createPayrollConcept,
      update: payrollConcepts.updatePayrollConcept,
      delete: payrollConcepts.deletePayrollConcept,
    },
    // Ajustes de contrato
    contractAdjustments: {
      list: payrollConcepts.getContractAdjustments,
      getByEmployee: payrollConcepts.getContractAdjustmentsByEmployee,
      create: payrollConcepts.createContractAdjustment,
      update: payrollConcepts.updateContractAdjustment,
      delete: payrollConcepts.deleteContractAdjustment,
      pause: payrollConcepts.pauseContractAdjustment,
      resume: payrollConcepts.resumeContractAdjustment,
    },
    // Aplicar bonos/descuentos a entradas de nómina
    applyBonuses: payrollConcepts.applyBonusesToEntry,
    applyDeductions: payrollConcepts.applyDeductionsToEntry,
  },
  equipment: {
    list: equipmentAPI.list,
    get: equipmentAPI.get,
    create: equipmentAPI.create,
    update: equipmentAPI.update,
    partialUpdate: equipmentAPI.partialUpdate,
    remove: equipmentAPI.remove,
  },
  // NUEVOS ENDPOINTS AGREGADOS
  warehouses: {
    list: require("./endpoints/warehouses").default.list,
    get: require("./endpoints/warehouses").default.get,
    create: require("./endpoints/warehouses").default.create,
    update: require("./endpoints/warehouses").default.update,
    partialUpdate: require("./endpoints/warehouses").default.partialUpdate,
    remove: require("./endpoints/warehouses").default.remove,
    getProducts: require("./endpoints/warehouses").default.getProducts,
    addProduct: require("./endpoints/warehouses").default.addProduct,
    updateProductStock: require("./endpoints/warehouses").default.updateProductStock,
    transferProducts: require("./endpoints/warehouses").default.transferProducts,
    getStockMovements: require("./endpoints/warehouses").default.getStockMovements,
    getStockSummary: require("./endpoints/warehouses").default.getStockSummary,
    adjustStock: require("./endpoints/warehouses").default.adjustStock,
  },
  jobTitles: {
    listDepartments: require("./endpoints/jobTitles").default.listDepartments,
    getDepartment: require("./endpoints/jobTitles").default.getDepartment,
    createDepartment: require("./endpoints/jobTitles").default.createDepartment,
    updateDepartment: require("./endpoints/jobTitles").default.updateDepartment,
    deleteDepartment: require("./endpoints/jobTitles").default.deleteDepartment,
    listJobTitles: require("./endpoints/jobTitles").default.listJobTitles,
    getJobTitle: require("./endpoints/jobTitles").default.getJobTitle,
    createJobTitle: require("./endpoints/jobTitles").default.createJobTitle,
    updateJobTitle: require("./endpoints/jobTitles").default.updateJobTitle,
    deleteJobTitle: require("./endpoints/jobTitles").default.deleteJobTitle,
  },
  equipmentTypes: {
    listTypes: require("./endpoints/equipmentTypes").default.listTypes,
    getType: require("./endpoints/equipmentTypes").default.getType,
    createType: require("./endpoints/equipmentTypes").default.createType,
    updateType: require("./endpoints/equipmentTypes").default.updateType,
    deleteType: require("./endpoints/equipmentTypes").default.deleteType,
    listMaintenances: require("./endpoints/equipmentTypes").default.listMaintenances,
    getMaintenance: require("./endpoints/equipmentTypes").default.getMaintenance,
    createMaintenance: require("./endpoints/equipmentTypes").default.createMaintenance,
    updateMaintenance: require("./endpoints/equipmentTypes").default.updateMaintenance,
    completeMaintenance: require("./endpoints/equipmentTypes").default.completeMaintenance,
    cancelMaintenance: require("./endpoints/equipmentTypes").default.cancelMaintenance,
    deleteMaintenance: require("./endpoints/equipmentTypes").default.deleteMaintenance,
    listAssignments: require("./endpoints/equipmentTypes").default.listAssignments,
    getAssignment: require("./endpoints/equipmentTypes").default.getAssignment,
    createAssignment: require("./endpoints/equipmentTypes").default.createAssignment,
    updateAssignment: require("./endpoints/equipmentTypes").default.updateAssignment,
    returnAssignment: require("./endpoints/equipmentTypes").default.returnAssignment,
    deleteAssignment: require("./endpoints/equipmentTypes").default.deleteAssignment,
  },
  schedulingResources: {
    listResources: require("./endpoints/schedulingResources").default.listResources,
    getResource: require("./endpoints/schedulingResources").default.getResource,
    createResource: require("./endpoints/schedulingResources").default.createResource,
    updateResource: require("./endpoints/schedulingResources").default.updateResource,
    deleteResource: require("./endpoints/schedulingResources").default.deleteResource,
    listExceptions: require("./endpoints/schedulingResources").default.listExceptions,
    getException: require("./endpoints/schedulingResources").default.getException,
    createException: require("./endpoints/schedulingResources").default.createException,
    updateException: require("./endpoints/schedulingResources").default.updateException,
    deleteException: require("./endpoints/schedulingResources").default.deleteException,
    getDashboard: require("./endpoints/schedulingResources").default.getDashboard,
  },
  nutritionalCertificates: {
    list: require("./endpoints/nutritionalCertificates").default.list,
    get: require("./endpoints/nutritionalCertificates").default.get,
    create: require("./endpoints/nutritionalCertificates").default.create,
    generateFromRecipe: require("./endpoints/nutritionalCertificates").default.generateFromRecipe,
    update: require("./endpoints/nutritionalCertificates").default.update,
    partialUpdate: require("./endpoints/nutritionalCertificates").default.partialUpdate,
    remove: require("./endpoints/nutritionalCertificates").default.remove,
    verify: require("./endpoints/nutritionalCertificates").default.verify,
    downloadPDF: require("./endpoints/nutritionalCertificates").default.downloadPDF,
    generateQR: require("./endpoints/nutritionalCertificates").default.generateQR,
    publish: require("./endpoints/nutritionalCertificates").default.publish,
    revoke: require("./endpoints/nutritionalCertificates").default.revoke,
  },
  analytics: {
    getDashboard: require("./endpoints/analytics").default.getDashboard,
    getSummary: require("./endpoints/analytics").default.getSummary,
    getInventoryStats: require("./endpoints/analytics").default.getInventoryStats,
    getOrdersStats: require("./endpoints/analytics").default.getOrdersStats,
    getCustomersStats: require("./endpoints/analytics").default.getCustomersStats,
    getTimeSeries: require("./endpoints/analytics").default.getTimeSeries,
    getFinancialDashboard: require("./endpoints/analytics").default.getFinancialDashboard,
  },
  qrCodes: {
    list: require("./endpoints/qrCodes").default.list,
    get: require("./endpoints/qrCodes").default.get,
    create: require("./endpoints/qrCodes").default.create,
    generateForProduct: require("./endpoints/qrCodes").default.generateForProduct,
    update: require("./endpoints/qrCodes").default.update,
    partialUpdate: require("./endpoints/qrCodes").default.partialUpdate,
    remove: require("./endpoints/qrCodes").default.remove,
    download: require("./endpoints/qrCodes").default.download,
    scan: require("./endpoints/qrCodes").default.scan,
    printBatch: require("./endpoints/qrCodes").default.printBatch,
    regenerate: require("./endpoints/qrCodes").default.regenerate,
    getScanStats: require("./endpoints/qrCodes").default.getScanStats,
  },
};

export default api;

// Export funciones de dashboard directamente
export const getCashFlow = dashboardEndpoints.getCashFlow;
export const getIncomeExpense = dashboardEndpoints.getIncomeExpense;
export const getFinancialDashboard = dashboardEndpoints.getFinancialDashboard;

// Export Purchase Orders y Suppliers
export const purchaseOrdersApi = purchaseOrdersAPI;
export const suppliersApi = suppliersAPI;
